import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Products from "./pages/products/Products";
import ContactUs from "./pages/contact-us/ContactUs";
import Transparency from "./pages/transparency/Transparency";
import AISummaryPage from "./pages/kb/ai-summary/page";
import KBPage from "./pages/kb/page";
import ArchitecturePage from "./pages/kb/architecture/page";
import EczodexGroup from "./pages/kb/eczodex-group/page";
import GlossaryPage from "./pages/kb/glossary/page";
import HowUscyWorksPage from "./pages/kb/how-uscy-works/page";
import NorthernTrustCustody from "./pages/kb/northern-trust-custody/page";
import RedeemPage from "./pages/kb/redeem/page";
import USCYPage from "./pages/kb/uscy/page";
import USCYDigitalLLCPage from "./pages/kb/uscy-digital-asset-llc/page";
import VaultQueueModel from "./pages/kb/vault-queue-model/page";
import VaultsAndRankingPage from "./pages/kb/vaults-and-ranking/page";
import WhatIsUSCYPage from "./pages/kb/what-is-uscy/page";
import YPPPage from "./pages/kb/ypp/page";
import YPPOverviewPage from "./pages/kb/ypp-overview/page";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<Products />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/transparency" element={<Transparency />} />
      {/* kb */}
      <Route path="/kb" element={<KBPage />} />
      <Route path="/kb/ai-summary" element={<AISummaryPage />} />
      <Route path="/kb/architecture" element={<ArchitecturePage />} />
      <Route path="/kb/eczodex-group" element={<EczodexGroup />} />
      <Route path="/kb/glossary" element={<GlossaryPage />} />
      <Route path="/kb/how-uscy-works" element={<HowUscyWorksPage />} />
      <Route
        path="/kb/northern-trust-custody"
        element={<NorthernTrustCustody />}
      />
      <Route path="/kb/redeem" element={<RedeemPage />} />
      <Route path="/kb/uscy" element={<USCYPage />} />
      <Route
        path="/kb/uscy-digital-asset-llc"
        element={<USCYDigitalLLCPage />}
      />
      <Route path="/kb/vault-queue-model" element={<VaultQueueModel />} />
      <Route path="/kb/vaults-and-ranking" element={<VaultsAndRankingPage />} />
      <Route path="/kb/what-is-uscy" element={<WhatIsUSCYPage />} />
      <Route path="/kb/ypp" element={<YPPPage />} />
      <Route path="/kb/ypp-overview" element={<YPPOverviewPage />} />
    </Routes>
  );
}

export default App;
